import { Spin } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const AuthWrapper = ({ children }) => {
  const [authChecked, setAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/check-auth/`,
          {
            withCredentials: true,
          },
        );

        const data = response.data;

        if (response.status === 200 && data.is_authenticated) {
          localStorage.setItem("auth", JSON.stringify(data));
          setIsAuthenticated(true);
        } else {
          // Not authenticated
          window.location.href = `${process.env.REACT_APP_BASE_URL}?next=${window.location.origin}/`;
        }
      } catch (error) {
        setAuthChecked(true);
        if (process.env.REACT_APP_SANDBOX === "true") {
          localStorage.setItem(
            "auth",
            JSON.stringify({
              is_authenticated: true,
              username: "11223344556677889900",
              userid: 103,
              full_name: "John Mena",
              access_token: process.env.REACT_APP_access_token,
              org: 36,
            }),
          );
          setIsAuthenticated(true);
        } else {
          window.location.href = `${process.env.REACT_APP_BASE_URL}?next=${window.location.origin}/`;
        }
      } finally {
        setAuthChecked(true);
      }
    };

    checkAuth();
  }, [navigate, location.pathname]);

  if (!authChecked) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <Spin size="large" />
      </div>
    );
  }

  return isAuthenticated ? children : null;
};

export default AuthWrapper;
